import * as pathToRegexp from "path-to-regexp";

import {apAppPath} from "./ap_app_path";

export const apAppLink = {
    base: () => apAppPath.base,
    applications: () => apAppPath.applications,
    login: () => apAppPath.login,
    logout: () => apAppPath.logout,
    passwordReset: () => apAppPath.passwordReset,
    newPassword: parseParams<{uid: string; token: string}>(apAppPath.newPassword)
};

/**
 * Helper
 */
function parseParams<T extends {}>(path: string) {
    const compiler = pathToRegexp.compile(path);
    return (params: T) => compiler(params);
}
